import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ChimeService } from '../chime.service';
import { SelectComponent, SelectOption } from '../../ui/select/select.component';

@Component({
  selector: 'app-call-blur-settings',
  standalone: true,
  imports: [
    SelectComponent,
    FormsModule,
    MatButtonModule,
    MatSlideToggleModule,
    TranslateModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="custom-context-menu-wrapper no-subscript d-flex flex-column gap-3 p-3 mb-2 w-[280px]">
      <!-- Title -->
      <div class="font-bold text-slate-800 text-sm border-b pb-1 mb-1">
        {{ 'VideoCall.VideoEffects.Title' | translate }}
      </div>

      <div class="d-flex flex-column gap-2">
        <mat-slide-toggle
          [checked]="chimeService.isBlurEnabled()"
          (change)="onBlurToggleChange($event.checked)"
          color="primary"
          class="text-xs">
          {{ 'VideoCall.VideoEffects.BackgroundBlur' | translate }}
        </mat-slide-toggle>

        @if (chimeService.isBlurEnabled()) {
          <div class="w-full text-left mt-1">
            <label class="form-label mb-1 block text-xs font-semibold text-slate-600">
              {{ 'VideoCall.BlurStrength.Label' | translate }}
            </label>
            <ui-select
              class="w-full"
              [options]="blurStrengthOptions()"
              [ngModel]="chimeService.blurStrength()"
              (valueChange)="onBlurStrengthChange($any($event))"
              [compact]="true"
            ></ui-select>
          </div>
        }
      </div>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
      }
      ui-select {
        display: block;
        width: 100%;
        :host::ng-deep .skz-select-trigger.compact {
          display: flex;
          width: 100%;
        }
      }
    `,
  ],
})
export class CallBlurSettingsComponent {
  chimeService = inject(ChimeService);
  private translate = inject(TranslateService);

  blurStrengthOptions = computed<SelectOption[]>(() => [
    { value: 'low', label: this.translate.instant('VideoCall.BlurStrength.Low') },
    { value: 'medium', label: this.translate.instant('VideoCall.BlurStrength.Medium') },
    { value: 'high', label: this.translate.instant('VideoCall.BlurStrength.High') },
  ]);

  onBlurToggleChange(enabled: boolean): void {
    this.chimeService.setBlurPreference(enabled);
  }

  onBlurStrengthChange(strength: 'low' | 'medium' | 'high'): void {
    this.chimeService.setBlurStrength(strength);
  }
}
